import Qs from "qs";
/**
 * Check if there is a tag group in the URL.
 * @param search URL query string.
 * @returns      True only if a tag group has been selected.
 */
export const isTagGroupInUrl = (search: string) => {
    const parsed = Qs.parse(search, { ignoreQueryPrefix: true });
    return "tagGroupId" in parsed || "agentTagGroupId" in parsed;
};
